export default __webpack_public_path__ + "locales/ar-SA/UploadPanel.json?hash=031e52fcfa25ad2c0f1c22561de04216";